/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { MenuItem } from '@mui/material';
import { RiShareForwardLine, RiFolderTransferLine, RiDeleteBinLine } from 'react-icons/ri';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { LanguageContext } from '../../../../libs/Context';
import { MediaContext } from '../..';
import { useDispatch, useSelector } from 'react-redux';
import { setDownloadFile, setZipFile } from '../../../../redux/MediakitRedux';
import { useNavigate, useParams } from 'react-router-dom';
import { Storage } from 'aws-amplify';

const ListMenu = (props) =>
{
	const { openShare, data, optionsData, handlePopup, setAnchorEl, setMediaDrivePopup } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	// const menuData = useSelector((state:any) => state?.mysession?.sideMenuData);
	const folderId = useParams()?.id || '';
	const { tab } = useContext(MediaContext);
	const tabVal = useParams()?.tab || '';
	// const [ currentUser, setCurrentUser ] = useState<any>();
	const feedManagement = useSelector((state:any) => state.mysession.configs?.feedManagement);
	const socialMediaConfiguration = useSelector((state:any) => state?.mysession?.userConfigs?.socialMediaConfiguration);

	const navigate = useNavigate();
	const imageCheck = data?.type === 1 && data?.media?.type && data?.media?.type?.split('/')[0] === 'image';
	const isEmpShareFromDriveEnabled = socialMediaConfiguration?.isSocialEnable && socialMediaConfiguration?.moduleEnabled?.includes('mediaDrive');
	const isCompanyShareFromDriveEnabled = socialMediaConfiguration?.isSocialEnable;
	const isPostCheck = data?.media?.type && [ 'image', 'video', 'application' ].includes(data?.media?.type?.split('/')[0]) && isEmpShareFromDriveEnabled && isCompanyShareFromDriveEnabled;

	console.log('isEmpShareFromDriveEnabled(**', isEmpShareFromDriveEnabled);
	console.log('isCompanyShareFromDriveEnabled(**', isCompanyShareFromDriveEnabled);

	const dispatch = useDispatch();

	const handleZippedFile = () => { handlePopup({}); dispatch(setZipFile([ optionsData ])); };
	const clickDownload = () => { handlePopup({}); dispatch(setDownloadFile([ optionsData ])); };

	const handleNavigate = () =>
	{
		if (tab === 4)
		{
			navigate(`/drive/design/${tabVal}/${data?.folderId}/${'edit'}`);
		}
		else
		{
			navigate(folderId ? `/drive/edit/${tabVal}/${window.btoa(data?.media?.key)}/${folderId}` : `/drive/edit/${tabVal}/${window.btoa(data?.media?.key)}`);
		}
	};
	const handleOpenPopup = async (dataD:any) =>
	{
		const key = dataD?.media?.key;
		const destinationKey = key.split('/')[1];
		const replaceKeyname = key.replace(destinationKey, 'feed');

		const lastIndex = replaceKeyname.lastIndexOf('/');

		const newKey = `${replaceKeyname.substring(0, lastIndex)}/${new Date().valueOf()}${dataD?.media?.name}`;

		await Storage.configure({
			bucket       : process.env.REACT_APP_S3_BUCKET,
			region       : process.env.REACT_APP_S3_BUCKET_REGION,
			customPrefix : {
				public : ''
			}
		});

		if (newKey && key)
		{
			const copiedObj:any = await Storage.copy({ key }, { key: newKey });

			const newObj = {
				url   : `${process.env.REACT_APP_S3_BASE_URL}/${copiedObj?.key}`,
				type  : dataD?.media?.type,
				key   : copiedObj?.key,
				title : copiedObj?.key.split('/').pop(),
				name  : dataD?.media?.name,
				size  : dataD?.media?.size,
				tab   : 0
			};

			setMediaDrivePopup([ newObj ]);
			setAnchorEl(null);
		}
	};

	const show = {
		edit        : (tab === 0 && imageCheck) || (tab === 2 && imageCheck) || tab === 4,
		share       : (tab === 0 || (tab === 2)),
		zip         :	[ 0, 1, 2 ].includes(tab) && !optionsData?.media?.type?.match('zip'),
		moveto      :	tab === 0 || tab === 2,
		rename      : tab === 0 || tab === 2 || tab === 4,
		// rename      : (tab === 0 || tab === 1 ||) (tab === 2 && edmTabVal !== 2) || (tab === 2 && edmTabVal === 2 && file?.admin),
		delete      : (tab === 3 || (tab === 1 && optionsData?.shareAccess === 3 && optionsData?.createdBy === userData?.userId)),
		restore     : tab === 3,
		movetotrash : [ 0, 2, 4 ]?.includes(tab),
		download   	: [ 0, 1, 2 ].includes(tab) && optionsData?.type === 1
	};

	const openDialog = (item) =>
	{
		handlePopup({ [item]: true });
	};

	// const getCompanyData = async () =>
	// {
	// 	const query = `?id=${userData?.companyId}&type=company`;

	// 	try
	// 	{
	// 		const res = await getCompaniesData(query);

	// 		if (res?.status)
	// 		{
	// 			setCurrentUser(res?.data);
	// 		}
	// 	}
	// 	catch (err)
	// 	{
	// 		catchErr(err);
	// 		console.log(err);
	// 	}
	// };

	// useEffect(() =>
	// {
	// 	if (isPostCheck)
	// 	{
	// 		getCompanyData();
	// 	}
	// }, [ isPostCheck ]);

	return (
		<>
			{/* {show?.edit &&
			<MenuItem value='share' className='menuIcon pdngHXS' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleNavigate(); }} onClick={handleNavigate}>
				<EditBrshSvg/>&nbsp;
				{language?.edit}
			</MenuItem>} */}
			{/* //instaed of edit customize is added according to new requirement */}
			 {imageCheck && tab !== 1 &&
				<MenuItem value='zip' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openDialog('customize'); }} onClick={() => openDialog('customize')}>
					<div className='flexInline pointer alignCntr'>
						<img src='/images/icons/editgrey.svg' alt='editBrush' className='newsFeedImage lightTxt'/>
						<span className='pdngLXS'>{language?.customize}</span>
					</div>
				</MenuItem>
			}
			{show?.share && <MenuItem value='share' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openShare(e, data); setAnchorEl(null); }} onClick={(e) => { openShare(e, data); setAnchorEl(null); }}>
				<RiShareForwardLine className='menuIcon' />&nbsp;
				{language?.share}
			</MenuItem>}
			{isPostCheck &&
			<MenuItem value='Post' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOpenPopup(data); }} onClick={() => handleOpenPopup(data)}>
				<img src='/images/icons/newsFeed.svg' alt='news-feed' className='newsFeedImage'/>&nbsp;&nbsp;
				<span className='capitalTxt'>{language?.post}</span>
			</MenuItem>}
			{show?.zip && <MenuItem value='zip' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleZippedFile(); }} onClick={handleZippedFile}>
				<FolderZipOutlinedIcon className='menuIcon'/>&nbsp;
				{language?.zip}
			</MenuItem>}

			{show?.download && <MenuItem value='download' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && clickDownload(); }} onClick={clickDownload}>
				<FileDownloadOutlinedIcon className='menuIcon' />&nbsp;
				{language?.download}
			</MenuItem>}

			{show?.moveto && <MenuItem value='MoveTo' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openDialog('move'); }} onClick={() => openDialog('move')}>
				<RiFolderTransferLine className='menuIcon'/>&nbsp;
				{language?.moveto}
			</MenuItem>}
			{show?.movetotrash && <MenuItem value='delete' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openDialog('trash'); }} onClick={() => openDialog('trash')}>
				<RiDeleteBinLine className='menuIcon' />&nbsp;
				{language?.moveToTrash}
			</MenuItem>}
			{show?.rename && <MenuItem value='rename' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openDialog('rename'); }} onClick={() => openDialog('rename')}>
				<DriveFileRenameOutlineIcon className='menuIcon'/>&nbsp;
				{language?.rename}
			</MenuItem>}

			{/* ///tab 3 options */}
			{show?.restore && <MenuItem value='restore' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openDialog('restore'); }} onClick={() => openDialog('restore')}>
				<ReplyOutlinedIcon className='menuIcon'/>&nbsp;
				{language?.restore}
			</MenuItem>}
			{show?.delete && <MenuItem value='delete' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openDialog('delete'); }} onClick={() => openDialog('delete')} >
				<RiDeleteBinLine className='menuIcon'/>&nbsp;
				{language?.delete}
			</MenuItem>
			}
		</>

	);
};

export default ListMenu;